/**
 * Resolve the corporate event type id used by modify-employee-roles.
 */
export function resolveModifyRoleEventTypeId(eventTypes = []) {
  const envId = process.env.REACT_APP_CORPORATE_MODIFY_ROLE_EVENT_TYPE_ID;
  if (envId) return envId;

  const candidates = new Set([
    "modify_employee_roles",
    "modify_employee_role",
    "modify-employee-roles",
    "modify-employee-role",
    "employee_role_modify",
  ]);
  const normalize = (value) => (value || "").toLowerCase();

  const direct = eventTypes.find((evt) =>
    candidates.has(normalize(evt.description))
  );
  if (direct?.id) return direct.id;

  const fuzzy = eventTypes.find((evt) => {
    const desc = normalize(evt.description);
    return desc.includes("modify") && desc.includes("role");
  });

  return fuzzy?.id || null;
}
